import React from 'react';
import { cn } from '../lib/utils';
import { useNavigation } from '../contexts/NavigationContext';

const SecondaryNav = ({ items, currentView }) => {
  const { navigate } = useNavigation();
  return (
    <div className="border-b bg-card/50 mb-6">
      <div className="container mx-auto px-4">
        <nav className="flex gap-1 overflow-x-auto">
          {items.map((item) => {
            const isActive = currentView === item.view;
            return (
              <button
                key={item.view}
                onClick={() => navigate(item.view)}
                className={cn(
                  "flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap",
                  isActive
                    ? "border-primary text-foreground"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted"
                )}
              >
                {item.icon && <item.icon className="h-4 w-4" />}
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default SecondaryNav;

